import { API } from "aws-amplify";
import * as mutations from "./../graphql/mutations";
import * as PreQuestions from "./PreQuestions";
import _ from "lodash";
import moment from "moment-timezone";
export class Booking {
  constructor() {}

  static async getEvent(code) {
    let date = moment();
    date = date.subtract(1, "days");
    const eventByCode = /* GraphQL */ `
      query EventByCode(
        $sortDirection: ModelSortDirection
        $filter: ModelEventFilterInput
        $limit: Int
        $nextToken: String
      ) {
        eventByCode(
          code: "${code}"
          sortDirection: $sortDirection
          filter: $filter
          limit: $limit
          nextToken: $nextToken
        ) {
          items {
            eventCompany {
              id
              name
              logo
            }
            id
            name
            code
            message
            description
            type
            iCalendar
            bloodDropStart
            bloodDropEnd
            urinePotLocation
            commsLink
            preQuestionTemplate
            registerInterest
            notifyRegisterInterest
            eventLocation(limit: 1000, filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                addressLine1
                postcode
                town
                createdAt
                eventSlotGroup(limit: 1000, filter: { isDeleted: { eq: 0 }, active: { eq: true }, date: { gt: "${date.toISOString()}" }}) {
                  items {
                    id
                    room
                    createdAt
                    date
                    capacity
                    eventSlot(limit: 1000) {
                      items {
                        id
                        length
                        time
                        type
                        booked
                        eventBooking(limit: 1) {
                          items {
                            id
                            isDeleted
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            eventCollectUserData(filter: { isDeleted: { eq: 0 } }) {
              items {
                id
                label
                questionType
                validation
                fieldType
                createdAt
                isDeleted
                success
                error
                hint
                eventCollectUserDataOptions {
                  items {
                    id
                    options
                  }
                }
              }
            }
          }
          nextToken
        }
      }
    `;

    const eventObj = await API.graphql({
      query: eventByCode,
      variables: {
        // code: code,
        filter: {
          status: { eq: "Live" },
          isDeleted: { eq: 0 }
        }
      },
      authMode: "API_KEY"
    });

    // Check array has all elements needed
    let valid = false;
    eventObj.data.eventByCode.items.map(event => {
      event.eventLocation.items.map(location => {
        location.eventSlotGroup.items.map(() => {
          valid = true;
        });
      });
    });
    return valid ? eventObj.data.eventByCode.items : false;
  }

  static bookingSteps(customFields, preQuestionTemplate) {
    let step = 0;
    let steps = {};

    steps.fluQuestions = {
      title: "",
      active: false,
      step: 0,
    };
    steps.covidQuestions = {
      title: "",
      active: false,
      step: 0,
    };

    if (preQuestionTemplate) {
      preQuestionTemplate.forEach(function (template) {
        step++;
        steps[template] = {
          title: PreQuestions[template].title,
          active: true,
          step: step,
        };
      });
    }

    const preQuestions = customFields.filter(
      (field) => field.questionType === "PREQUESTION"
    );
    steps.premilinary = {
      title: "",
      active: false,
      step: 0,
    };
    if (preQuestions.length > 0) {
      step++;
      steps.premilinary = {
        title: "Preliminary questions",
        active: true,
        step: step,
      };
    }

    if (preQuestions.length > 0) {
      step++;
      steps.slots = {
        title: "Select time",
        active: true,
        step: step++,
      };

      steps.contactdetails = {
        title: "Contact details",
        active: true,
        step: step++,
      };

      steps.preassessment = {
        title: "Complete",
        active: true,
        step: step++,
      };
    } else {
      steps.premilinary = {
        title: "",
        active: false,
        step: step++,
      };

      steps.slots = {
        title: "Select location, date and time",
        active: true,
        step: step++,
      };

      steps.contactdetails = {
        title: "Enter contact details",
        active: true,
        step: step++,
      };

      steps.preassessment = {
        title: "Pre-assessment questions",
        active: true,
        step: step++,
      };
    }
    return steps;
  }

  static async createBookingWorkshop({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    capacity,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      eventSlot: eventBookingEventSlotId,
      startTime: startTime,
      capacity: capacity
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processBookingWorkshopQL = `mutation ProcessBookingWorkshop(
      $input: CreateBookingWorkshopInput!
    ) {
      processBookingWorkshop(input: $input){
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        twentyFourHourReminder
        fortyEightHourReminder
        searchField
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
        }
      }
    }`;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processBookingWorkshopQL,
        variables: {
          input
        },
        authMode: "API_KEY"
      });
      // const { data: { processBookingWorkshop } } = bookingResult;
      const {
        data: {
          processBookingWorkshop: { eventSlot }
        }
      } = bookingResult;

      let booking = {
        eventSlot: eventSlot
      };
      return booking;
    } catch (err) {
      console.log(err, "err");
      return false;
    }
  }

  static async createBookingWorkshopAuthenticated({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    capacity,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      eventSlot: eventBookingEventSlotId,
      startTime: startTime,
      capacity: capacity
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processBookingWorkshopQL = `mutation ProcessBookingWorkshop(
      $input: CreateBookingWorkshopInput!
    ) {
      processBookingWorkshop(input: $input){
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        twentyFourHourReminder
        fortyEightHourReminder
        searchField
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            assignedTo
            eventLocation {
              event {
                name
                commsTemplate
                commsLink
                iCalendar
                preQuestionTemplate
                eventCompany {
                  name
                }
              }
            }
          } 
        }
      }
    }`;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processBookingWorkshopQL,
        variables: {
          input
        },
        authMode: "AMAZON_COGNITO_USER_POOLS"
      });
      const { data: { processBookingWorkshop } } = bookingResult;
      const { data: { processBookingWorkshop: { eventSlot } } } = bookingResult;
      const { data: { processBookingWorkshop: { eventSlot: { eventSlotGroup } } } } = bookingResult;
      const { data: { processBookingWorkshop: { eventSlot: { eventSlotGroup: { eventLocation } } } } } = bookingResult;
      const { data: { processBookingWorkshop: { eventSlot: { eventSlotGroup: { eventLocation: { event } } } } } } = bookingResult;
      const { data: { processBookingWorkshop: { eventSlot: { eventSlotGroup: { eventLocation: { event: { eventCompany } } } } } } } = bookingResult;

      let booking = {
        firstname: processBookingWorkshop.firstname,
        lastname: processBookingWorkshop.lastname,
        email: processBookingWorkshop.email,
        mobile: processBookingWorkshop.mobile,
        event: event,
        eventSlotGroup: eventSlotGroup,
        eventLocation: eventLocation,
        eventSlot: eventSlot,
        eventCompany: eventCompany
      };
      return booking;
    } catch (err) {
      console.log(err, "err");
      return false;
    }
  }

  static async createBooking({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      startTime: startTime.toISOString(),
      eventSlot: eventBookingEventSlotId
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processingBooking = `mutation ProcessingBooking(
      $input: CreateBookingInput!
    ) {
      processBooking(input: $input){
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
        }
      }
    }`;

    const updateEventSlot = `mutation UpdateEventSlot(
      $input: UpdateEventSlotInput!
      $condition: ModelEventSlotConditionInput
    ) {
      updateEventSlot(input: $input, condition: $condition) {
        id
        time
        length
        type
        booked
        createdAt
        updatedAt
        isDeleted
      }
    }
  `;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processingBooking,
        variables: {
          input
        },
        authMode: "API_KEY"
      });
      const {
        data: {
          processBooking: { eventSlot }
        }
      } = bookingResult;

      // Need to do this to trigger subscription event and make slot unavailable
      await API.graphql({
        query: updateEventSlot,
        variables: { input: { id: eventSlot.id, booked: 1 } },
        authMode: "API_KEY"
      });

      let booking = {
        eventSlot: eventSlot
      };
      return booking;
    } catch (err) {
      return false;
    }
  }

  static async createBookingAuthenticated({
    firstname,
    lastname,
    email,
    mobile,
    dob,
    customData,
    startTime,
    eventBookingEventSlotId
  }) {
    let input = {
      firstname: firstname.trim(),
      lastname: lastname.trim(),
      email: email.trim(),
      dob: dob,
      customData: JSON.stringify(customData),
      startTime: startTime.toISOString(),
      eventSlot: eventBookingEventSlotId
    };

    if (mobile) {
      input.mobile = mobile;
    }

    const processingBooking = `mutation ProcessingBooking(
      $input: CreateBookingInput!
    ) {
      processBooking(input: $input){
        id
        firstname
        lastname
        email
        mobile
        dob
        customData
        createdAt
        twentyFourHourReminder
        fortyEightHourReminder
        searchField
        isDeleted
        eventSlot {
          id
          time
          length
          type
          booked
          isDeleted
          eventSlotGroup {
            id
            room
            date
            createdAt
            isDeleted
            assignedTo
            eventLocation {
              event {
                name
                commsTemplate
                preQuestionTemplate
                commsLink
                iCalendar
                bloodDropStart
                bloodDropEnd
                urinePotLocation
                eventCompany {
                  name
                }
              }
            }
          } 
        }
      }
    }`;

    const updateEventSlot = `mutation UpdateEventSlot(
      $input: UpdateEventSlotInput!
      $condition: ModelEventSlotConditionInput
    ) {
      updateEventSlot(input: $input, condition: $condition) {
        id
        time
        length
        type
        booked
        createdAt
        updatedAt
        isDeleted
        eventSlotGroup {
          id
          room
          date
          createdAt
          isDeleted
          assignedTo
          eventLocation {
            event {
              name
              commsTemplate
                eventCompany {
                    name
                }
            }
          }
        } 
      }
    }
  `;

    try {
      // success
      const bookingResult = await API.graphql({
        query: processingBooking,
        variables: {
          input
        },
        authMode: "AMAZON_COGNITO_USER_POOLS"
      });
      const {
        data: { processBooking }
      } = bookingResult;
      const {
        data: {
          processBooking: { eventSlot }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: { eventSlotGroup }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: { eventLocation }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: { event }
              }
            }
          }
        }
      } = bookingResult;
      const {
        data: {
          processBooking: {
            eventSlot: {
              eventSlotGroup: {
                eventLocation: {
                  event: { eventCompany }
                }
              }
            }
          }
        }
      } = bookingResult;

      // Need to do this to trigger subscription event and make slot unavailable
      await API.graphql({
        query: updateEventSlot,
        variables: { input: { id: eventSlot.id, booked: 1 } },
        authMode: "AMAZON_COGNITO_USER_POOLS"
      });

      let booking = {
        firstname: processBooking.firstname,
        lastname: processBooking.lastname,
        email: processBooking.email,
        mobile: processBooking.mobile,
        event: event,
        eventSlotGroup: eventSlotGroup,
        eventLocation: eventLocation,
        eventSlot: eventSlot,
        eventCompany: eventCompany
      };
      return booking;
    } catch (err) {
      return false;
    }
  }

  static async updateBooking({
    id,
    firstname,
    lastname,
    email,
    mobile,
    dob,
    isDeleted,
    eventBookingEventSlotId,
  }) {
    const bookingResult = await API.graphql({
      query: mutations.updateEventBooking,
      variables: {
        input: {
          id: id,
          firstname: firstname,
          lastname: lastname,
          email: email,
          mobile: mobile,
          dob: dob,
          isDeleted: isDeleted,
          eventBookingEventSlotId: eventBookingEventSlotId
        }
      },
      authMode: "AMAZON_COGNITO_USER_POOLS"
    });
    const booking = bookingResult.data.updateEventBooking;

    const updateEventSlot = `mutation UpdateEventSlot(
            $input: UpdateEventSlotInput!
            $condition: ModelEventSlotConditionInput
          ) {
            updateEventSlot(input: $input, condition: $condition) {
              id
              time
              length
              type
              booked
              isDeleted
              eventSlotGroup {
                id
                room
                date
                createdAt
                isDeleted
                assignedTo
                eventLocation {
                  event {
                    name
                    commsTemplate
                    eventCompany {
                        name
                    }
                  }
                }
              } 
            }
          }
        `;

    const eventSlotResult = await API.graphql({
      query: updateEventSlot,
      variables: { input: { id: booking.eventSlot.id, booked: 1 } },
      authMode: "AMAZON_COGNITO_USER_POOLS"
    });

    booking.eventSlotGroup =
      eventSlotResult.data.updateEventSlot.eventSlotGroup;
    booking.event =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.name;
    booking.commsTemplateId =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.commsTemplate;
    booking.company =
      eventSlotResult.data.updateEventSlot.eventSlotGroup.eventLocation.event.eventCompany.name;
    return booking;
  }

  static async sendBookingEmail(input) {
    var body = {
      eventId: input.eventSlotId
    };

    const result = await API.post(
      "heLambdaNotifyUserOfEventApi",
      "/events/sendEventEmailNew/",
      {
        body
      }
    );
    return result;
  }

  static async sendTextMessage(input) {
    var body = {
      eventId: input.eventSlotId
    };

    API.post("heLambdaNotifyUserOfEventApi", "/events/sendSmsMessageNew/", {
      body
    });
  }

  static async cancelBooking({
    bookingId,
    slotId,
    iCalendar,
    type,
    email,
    firstname,
    room,
    time,
    date,
    event,
    company,
    booked
  }) {
    var body = {
      baseUrl: window.location.origin,
      slotId: slotId
    };
    const result = await API.post(
      "heLambdaNotifyUserOfEventApi",
      "/events/sendCancelBookingEmail",
      {
        body
      }
    );
    var body = { bookingId: bookingId };
    await API.post("heLambdaPublicQueryApi", "/query/deleteBooking", {
      body
    });

    if (type) {
      const updateEventSlot = `mutation UpdateEventSlot(
        $input: UpdateEventSlotInput!
        $condition: ModelEventSlotConditionInput
      ) {
        updateEventSlot(input: $input, condition: $condition) {
          id
        }
      }
    `;

      // If workshop
      let customersBookedIn = 0;
      if (type === "workshop") {
        customersBookedIn = booked;
        customersBookedIn--;
      }

      await API.graphql({
        query: updateEventSlot,
        variables: { input: { id: slotId, booked: customersBookedIn } },
        authMode: "API_KEY"
      });
    }
    return result;
  }

  static customFields(event) {
    let collectUserDatas = [];
    const rules = {
      required: (v) => !!v || "This field is required.",
      email: (v) => /.+@.+/.test(v) || "E-mail must be valid",
    };
    if (event) {
      event.eventCollectUserData.items.forEach(function (collectUserData) {
        // Validation
        let validation = [];
        collectUserData.validation.forEach(function (validationType) {
          if (validationType === "required") {
            validation.push(rules.required);
          }
          if (validationType === "email") {
            validation.push(rules.email);
          }
        });

        let fieldName = collectUserData.label
          .trim() //might need polyfill if you need to support older browsers
          .toLowerCase() //lower case everything
          .replace(
            /([^A-Z0-9]+)(.?)/gi, //match multiple non-letter/numbers followed by any character
            function () {
              return arguments[2].toUpperCase(); //3rd index is the character we need to transform uppercase
            }
          );

        if (collectUserData.questionType === "EMPLOYEE") {
          fieldName = "employeeNumber";
        }

        // Build custom fields
        collectUserDatas.push({
          id: collectUserData.id,
          label: collectUserData.label,
          fieldName: fieldName,
          success: collectUserData.success,
          error: collectUserData.error,
          hint: collectUserData.hint,
          questionType: collectUserData.questionType,
          fieldType: collectUserData.fieldType,
          validation: validation,
          options: [],
        });

        // If select box get select options
        if (collectUserData.fieldType === "select") {
          if (collectUserData.eventCollectUserDataOptions.items.length > 0) {
            let opts = collectUserData.eventCollectUserDataOptions.items.map(
              function (option) {
                return {
                  text: option.options,
                  value: option.options,
                };
              }
            );
            opts = _.orderBy(opts, "text", "asc");
            collectUserDatas[collectUserDatas.length - 1].options = opts;
          }
        }
      });
      return collectUserDatas;
    }
  }
}
